<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button type="button" id="btnToevoegen" class="btn btn-primary btn-xs" @click.prevent="Save">
          <font-awesome-icon :icon="['far', 'check']" />
          {{ translation(12980) }}
        </button>
        <button type="button" id="btnCancel" class="btn btn-primary btn-xs" @click.prevent="forceRerender()">
          <font-awesome-icon icon="times" />
          {{ translation(17) }}
        </button>
        <button
          type="button"
          id="btnDelete"
          class="btn btn-primary btn-xs"
          v-if="deleteVisible"
          @click.prevent="openConfirm"
        >
          <font-awesome-icon icon="times" />
          {{ translation(8756) }}
        </button>
      </template>
    </XVactionbar>
    <XVvalidationMessage> </XVvalidationMessage>
    <div class="row margin20">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(4891) }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p v-html="translation(4892)"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <fieldset>
          <extOrgDetailsForm class="margin20" v-model="extOrg" />
        </fieldset>
        <XVMetaDataBlock
          class="margin20"
          name="XVMetaDataBlock"
          infoRequiredName="TblExternalOrganizationInfoRequired"
          :parameters="MetadataParameters"
        ></XVMetaDataBlock>
      </div>
    </div>
    <modal v-model="showConfirm" title="Modal 1" ref="modal" id="modal-demo" :header="false">
      <p v-html="translation(8757)"></p>
      <div slot="footer" class="modalconfirmbuttons">
        <button
          id="btnDeleteModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="deleteConfirm()"
        >
          {{ translation(23) }}
        </button>
        <button
          id="btnCloseModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="closeConfirm"
        >
          {{ translation(17) }}
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { FAMixin } from 'pevueglobal'
import { sync } from 'vuex-pathify'
import extOrgDetailsForm from './ExtOrgDetailsForm'

export default {
  mixins: [FAMixin],
  components: {
    extOrgDetailsForm
  },
  data: function() {
    return {
      MetadataParameters: [],
      showConfirm: false
    }
  },
  computed: {
    ...mapGetters('SPE650BHExtOrgDetails', ['prfgrpExtOrg', 'deleteVisible']),
    extOrg: sync('SPE650BHExtOrgDetails/extOrg')
  },
  async mounted() {
    this.getTexten()
    this.startLoading({ showmessage: false, disablepage: false })
    await this.getExtOrgDetails()
    this.stopLoading()
  },
  methods: {
    ...mapActions('SPE650BHExtOrgDetails', [
      'getTexten',
      'getExtOrgDetails',
      'saveExtOrgDetails',
      'deleteExtOrgDetails'
    ]),
    ...mapActions('Metafields', ['getMetaData']),
    async Save() {
      // validatie via veelidate, valideert ook de metavelden
      const valid = await this.XVvalidate()
      if (valid) {
        // sla pagina gegevens + meta gegevens op
        await this.saveExtOrgDetails('TblExternalOrganizationInfoRequired')
      }
    },
    async forceRerender() {
      // als cancel button word ingedrukt alle gegevens opnieuw ophalen
      this.getExtOrgDetails()
      await this.getMetaData({ infoRequiredName: 'TblExternalOrganizationInfoRequired' })
      this.$forceUpdate()
    },
    openConfirm: function() {
      this.showConfirm = true
    },
    closeConfirm: function() {
      this.showConfirm = false
    },
    deleteConfirm: function() {
      this.deleteExtOrgDetails()
      this.showConfirm = false
    }
  }
}
</script>
